const { pageView } = require('./src/utils/analytics');

exports.onRouteUpdate = ({ location }) => {
  pageView(location);
};
